import {resources} from "../../../../core/models/resource/resources";

export const planFactExceptionResourceType = resources['plan-fact-exceptions'];
